<h3 mat-dialog-title>Link Project</h3>
<mat-dialog-content>
  @if (!showMore()) {
    <div class="row">
      <div class="col-6">
        <mat-form-field style="width: 100%;">
          <input autocomplete="off" type="text" matInput placeholder="Project Number or Name..." [(ngModel)]="searchTerm" (input)="debounceSearch($event.target.value)" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        @if (isLoading()) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
    </div>

    <table class="my-3" mat-table matSort [dataSource]="dataSource()" [hidden]="dataSource().data.length < 1">
      <ng-container matColumnDef="projectNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Number</th>
        <td mat-cell *matCellDef="let project">{{ project.projectNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name</th>
        <td mat-cell *matCellDef="let project">{{ project.projectName }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onProjectSelect(row.projectNumber)"></tr>
    </table>

    @if (dataSource().data.length < 1 && !isLoading() && hasSearched()) {
      <div class="text-center my-3">
        <h4>No Results Found</h4>
      </div>
    }
  }
  @else {
    <table>
      <tr>
        <td>
          @if (selectedProject()!.projectNumber) {
            <h4>{{selectedProject()!.projectName}} (#{{selectedProject()!.projectNumber}})</h4>
          } @else {
            <h4>{{selectedProject()!.projectName}} (No job #)</h4>
          }
        </td>
      </tr>
      <br>
      <tr>
        <td>
          <h6>Address:</h6> {{selectedProject()!.address ?? 'N/A'}}<br>
          {{selectedProject()!.city ?? 'N/A'}}, {{selectedProject()!.region ?? 'N/A'}}  {{selectedProject()!.zip ?? 'N/A'}}
        </td>
      </tr>
      <br>
      <tr>
        <td>
          <h6>Profit Center:</h6> {{selectedProject()!.profitCenterName ?? 'N/A'}}
          <span>({{selectedProject()!.profitCenterCode ?? 'N/A'}})</span>
        </td>
      </tr>
      <br>      
      <tr>
        <td>
          <h6>Start Date:</h6> {{selectedProject()!.fromDate | date: 'mediumDate'}}
        </td>
      </tr>      
      <br>      
      <tr>
        <td>
          <h6>End Date:</h6> {{selectedProject()!.toDate | date: 'mediumDate'}}
        </td>
      </tr>      
      <br>
      <tr>
        <td>
          <h6>Market Segment:</h6> {{selectedProject()!.primaryBuildingType}}
        </td>
      </tr>
      <br>
      <tr>
        <td>
          <i>Please make sure you are creating a roadmap in the same region as this project.</i>
        </td>
      </tr>
    </table>
    <br>
  }
</mat-dialog-content>

@if (showMore()) {
  <mat-dialog-actions style="justify-content: space-between;">
    <button matButton="filled" class="accent" (click)="onBackClick()">
        <mat-icon>arrow_back</mat-icon>
        Back to Results
    </button>
    <button matButton="filled" class="primary" (click)="onProjectSelectClick()">
        Select Project
        <mat-icon>arrow_forward</mat-icon>
    </button>
  </mat-dialog-actions>
}
